/**
 * Static locale constants - no dependency on RMS data or derived types.
 * These are fixed values used across the app; derived constants live in locale-config.derived-constants.
 */

// =============================================================================
// CORE LOCALE CONSTANTS
// =============================================================================

/** Locale cookie name */
export const LOCALE_COOKIE = 'NEXT_PREFERRED_LOCALE'

/** Region details localStorage key */
export const REGION_DETAILS_LOCAL_STORAGE_KEY = 'REGION_DETAILS'

/** Locale format template (lowercase country) */
export const LOCALE_FORMAT = '{{language}}-{{country}}'

/** Locale format template for standard format (uppercase country) */
export const LOCALE_FORMAT_STANDARD = '{{language}}-{{countryUpper}}'

/** Default locale identifier */
export const DEFAULT_LOCALE = 'en-us'

/** Default language (en-us format) */
export const DEFAULT_LANGUAGE = 'en-us' // TODO(sachin_i18n): get language from Next preferred cookie

/** Default locale prefix (en-us) */
export const DEFAULT_LOCALE_PREFIX = 'en-us'

/** Fallback region ID for US */
export const FALLBACK_REGION_ID = 101

// =============================================================================
// LOCALE STANDARD FORMATS
// All the below will be cleared in phase 2 code migration as there wont be any lang specific code
// =============================================================================

/** Standard locale format for US (en-US) */
export const LOCALE_STANDARD_FORMAT = 'en-US'

/** Standard locale format for Canada English (en-CA) */
export const LOCALE_STANDARD_FORMAT_CANADA = 'en-CA'

/** Standard locale format for Canada French (fr-CA) */
export const LOCALE_STANDARD_FORMAT_CANADA_FRENCH = 'fr-CA'

// =============================================================================
// INTEGRATION CONSTANTS
// =============================================================================

/** Klarna region-specific client IDs */
export const KLARNA_REGION_WISE_CLIENT_ID_CONFIG = {
  us: 'b422da9d-78be-55a0-a693-7d1c18ca1b82',
  ca: 'de6c249a-249b-548b-80e8-ff6a227f8957',
}

// =============================================================================
// DEPRECATED CONSTANTS (For backward compatibility only)
// All the below will be cleared in phase 2 code migration as there wont be any lang specific code
// =============================================================================

/**  Use string literals directly: 'en' | 'fr' - Kept for backward compatibility only */
export enum LANGUAGE_CODE {
  EN = 'en',
  FR = 'fr',
}

/**  Use string literals directly - Kept for backward compatibility only */
export enum COUNTRY_CODE {
  US = 'us',
  CA = 'ca',
}
